export default __webpack_public_path__ + "static/media/sensotrend_connect_open_downloaded.d66355d5.png";